module.exports = __webpack_public_path__ + "static/media/lineage-graph-fullscreen.b9dfba15.png";